import { render } from "./BaseCreateFieldset.vue?vue&type=template&id=6187d1a6"
import script from "./BaseCreateFieldset.vue?vue&type=script&lang=js"
export * from "./BaseCreateFieldset.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__